import darkTheme from '../../../styles/themes/darkTheme';
import lightTheme from '../../../styles/themes/lightTheme';

const savedTheme = localStorage.getItem('theme');

const currentTheme = (savedTheme === 'dark') ? darkTheme : lightTheme as any; 

const menuItems = (t) => [

    { 
        type: 'item', 
        section: 'preferences', 
        text: 'preferences', 
        key:'i-preferences' 
    },
    // { 
        // type: 'item', 
        // section: 'notifications', 
        // text: t('alerts'), 
        // key: 'i-notifications'
    // }, 
    { 
        type: 'item', 
        section: 'account', 
        text: 'account', 
        key:'i-account'
    },

];

export default menuItems; 